import type { ReactNode } from "react";

interface PanelProps {
  title?: string;
  eyebrow?: string;
  children: ReactNode;
  variant?: "default" | "soft" | "accent";
}

export function Panel({ title, eyebrow, children, variant = "default" }: PanelProps) {
  return (
    <section className={`panel panel-${variant}`}>
      {eyebrow ? <p className="panel-eyebrow">{eyebrow}</p> : null}
      {title ? <h2>{title}</h2> : null}
      {children}
    </section>
  );
}

type StatusTone = "default" | "success" | "warning" | "danger";

interface StatProps {
  label: string;
  value: string;
  tone?: StatusTone;
}

export function Stat({ label, value, tone = "default" }: StatProps) {
  return (
    <div className={`stat stat-${tone}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

interface StatusBadgeProps {
  children: ReactNode;
  tone?: StatusTone;
  withCheck?: boolean;
}

export function StatusBadge({ children, tone = "default", withCheck = false }: StatusBadgeProps) {
  return (
    <span className={`status-badge status-${tone}`}>
      {withCheck ? <span aria-hidden="true">✓</span> : null}
      {children}
    </span>
  );
}
